import styled from 'styled-components'
import { animated } from 'react-spring'

export default styled(animated.div)`
    margin-bottom: ${({ theme }) =>theme.paddingBox};
    width: 100%;
`
